import { CARDS } from '../../game/build';
import { ITEMS, RARITY_COLOR, type Rarity } from '../../game/items';
import { api } from './api';
import { ui } from './store';

/** Death panel: the world turns grey; revive at a checkpoint or with a plume. */
export function DeathOverlay() {
  const d = ui.deathOptions.value;
  if (!d) return null;
  const game = api() as unknown as { revive(inPlace: boolean): void; leaveInstance(): void };
  return (
    <div class="death panel interactive">
      <h2>You have fallen</h2>
      <div style={{ padding: '10px 16px', color: 'var(--text-1)' }}>
        {d.canCheckpoint ? 'Return to the nearest checkpoint, or rise where you fell with a Phoenix Plume.' : 'Wait for your party, or leave the instance.'}
      </div>
      <div class="opts">
        {d.canPlume && (
          <button class="btn" onClick={() => game.revive(true)}>
            Phoenix Plume
          </button>
        )}
        {d.canCheckpoint ? (
          <button class="btn btn--gold" onClick={() => game.revive(false)}>
            Revive at checkpoint
          </button>
        ) : (
          <button class="btn" onClick={() => game.leaveInstance()}>
            Leave instance
          </button>
        )}
      </div>
    </div>
  );
}

/** Reward summary shown after quests, dungeon clears and chests. */
export function RewardsOverlay() {
  const r = ui.rewards.value;
  if (!r) return null;
  const close = () => (ui.rewards.value = null);
  return (
    <div class="rewards panel interactive" onPointerDown={(e) => e.stopPropagation()}>
      <div class="panel__title">{r.subtitle ?? 'Rewards'}</div>
      <div style={{ padding: '12px 16px' }}>
        <h3 class="rw-title">{r.title}</h3>
        <div class="rw-grid">
          {r.xp ? <div class="rw-item">✦ {r.xp.toLocaleString('en-US')} XP</div> : null}
          {r.silver > 0 && <div class="rw-item">◉ {r.silver.toLocaleString('en-US')} silver</div>}
          {r.gold > 0 && <div class="rw-item" style={{ color: '#ffd24a' }}>◉ {r.gold.toLocaleString('en-US')} gold</div>}
          {r.items.map((it) => {
            const def = ITEMS[it.id];
            return (
              <div key={it.id} class="rw-item" style={{ color: def ? RARITY_COLOR[def.rarity] : undefined }}>
                {def?.name ?? it.id} ×{it.count}
              </div>
            );
          })}
          {r.equip.map((e, i) => (
            <div key={i} class="rw-item" style={{ color: RARITY_COLOR[e.rarity as Rarity] }}>
              {e.name}
            </div>
          ))}
          {r.cards.map((c) => (
            <div key={c} class="rw-item" style={{ color: '#ffd070' }}>
              Card: {CARDS[c]?.name ?? c}
            </div>
          ))}
        </div>
        <div style={{ textAlign: 'right', marginTop: 12 }}>
          <button class="btn btn--gold" onClick={close}>
            Collect
          </button>
        </div>
      </div>
    </div>
  );
}
